<div class="search-skeleton-container">
  <div class="container">
    <div class="main-container">
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
      <ion-skeleton-text class="item" animated></ion-skeleton-text>
    </div>
  </div>
</div>
